var map = {
	"./baobiao.svg": "4a94",
	"./dict-manage.svg": "4f35",
	"./entry.svg": "b145",
	"./exit-fullscreen.svg": "dbc7",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./fullscreen.svg": "9921",
	"./guanwang.svg": "96b2",
	"./hamburger-menu.svg": "7d10",
	"./hamburger.svg": "bd6a",
	"./home.svg": "6bbe",
	"./kucun.svg": "52707",
	"./log.svg": "fea0",
	"./logout.svg": "0175",
	"./menu-manage.svg": "16be",
	"./money.svg": "3046",
	"./monitor.svg": "cdec",
	"./open.svg": "ace42",
	"./out.svg": "a673",
	"./password.svg": "2a3d",
	"./product.svg": "8d30",
	"./recycle-bin.svg": "f32d",
	"./role-manage.svg": "7047",
	"./search.svg": "8e8d",
	"./setting.svg": "05ff",
	"./system-manage.svg": "d5cb",
	"./user-manage.svg": "507b",
	"./warehouse.svg": "a805",
	"./warning.svg": "7e6f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";